export enum ActionCode {
  ACC_MESS = 'ACC_MESS',
  IMP_DOSS = 'IMP_DOSS',
  TRA_JUS = 'TRA_JUS',
  EDI_CONT_FIN = 'EDI_CONT_FIN',
  SIG_CONT_FIN = 'SIG_CONT_FIN',
  ACC_HIST_DOSS = 'ACC_HIST_DOSS',
  SIG_DEL_DOC = 'SIG_DEL_DOC',
  DEM_FINA_DOSS = 'DEM_FINA_DOSS',
  ANN_ICAR = 'ANN_ICAR',
  DUP_DOSS = 'DUP_DOSS',
  REN_LIVR = 'REN_LIVR',
  OCR_ESIGN_VAD = 'OCR_ESIGN_VAD',
  SUP_DEVI = 'SUP_DEVI',
  MET_SUIT = 'MET_SUIT',
  MOD_DEVI = 'MOD_DEVI',
  DEROG_VR = 'DEROG_VR'
}

export const messagingAvailableList = [ActionCode.ACC_MESS];
export const documentsAvailableList = [ActionCode.IMP_DOSS, ActionCode.TRA_JUS];
export const signatureAvailableList = [ActionCode.SIG_CONT_FIN];
export const fileHistoryAvailableList = [ActionCode.ACC_HIST_DOSS];
export const deliveryAvailableList = [ActionCode.SIG_DEL_DOC, ActionCode.DEM_FINA_DOSS];
export const exemptionVrAvailableList = [ActionCode.DEROG_VR];
export const duplicationAvailableList = [ActionCode.DUP_DOSS];
export const cancellationAvailableList = [ActionCode.MET_SUIT];

export type SaveLeadResponse = {
  id: number;
  reference: string;
  accessToken: string;
};
